export const DEFAULT_MINIMUM_SUPPORTED_BROWSER_VERSIONS = {
  Chrome: { softLimit: 108, hardLimit: 70 },
  Edge: { softLimit: 108, hardLimit: 106 },
  Firefox: { softLimit: 102, hardLimit: 90 },
  IE: { softLimit: 11, hardLimit: 11 },
  Opera: { softLimit: 93, hardLimit: 89 },
  Safari: { softLimit: 11, hardLimit: 10 },
  WebKit: { softLimit: 604, hardLimit: 600 },
  MobileChrome: { softLimit: 109, hardLimit: 105 },
  MobileFirefox: { softLimit: 109, hardLimit: 105 },
  MobileSafari: { softLimit: 11, hardLimit: 10 },
  UCBrowser: { softLimit: 13.4, hardLimit: 13.0 },
  SamsungInternet: { softLimit: 18, hardLimit: 4 },
  AndroidBrowser: { softLimit: 4, hardLimit: 3 },
  Electron: { softLimit: 17, hardLimit: 16 },
};

export const UNSUPPORTED_BROWSERS = ["OperaMini"];

export const BROWSER_UPGRADE_PAGE_LINKS = {
  Chrome: "https://www.google.com/chrome/update",
  Edge: "https://support.microsoft.com/en-us/topic/microsoft-edge-update-settings-af8aaca2-1b69-4870-94fe-18822dbb7ef1#:~:text=Update%20once,Download%20and%20install%20to%20proceed",
  Firefox: "https://support.mozilla.org/en-US/kb/update-firefox-latest-release",
  IE: "https://support.microsoft.com/en-us/topic/microsoft-edge-update-settings-af8aaca2-1b69-4870-94fe-18822dbb7ef1#:~:text=Update%20once,Download%20and%20install%20to%20proceed",
  Opera: "https://help.opera.com/en/latest/crashes-and-issues/#updateBrowser",
  Safari: "https://support.apple.com/HT204416",
  WebKit: "https://support.apple.com/HT204204",
  MobileChrome:
    "https://play.google.com/store/apps/details?id=com.android.chrome&hl=en_IN&gl=US",
  MobileFirefox:
    "https://play.google.com/store/apps/details?id=org.mozilla.firefox&hl=en_IN&gl=US",
  MobileSafari: "https://support.apple.com/HT204416",
  UCBrowser:
    "https://play.google.com/store/apps/details?id=com.UCMobile.intl&hl=en_IN&gl=US",
  SamsungInternet:
    "https://play.google.com/store/apps/details?id=com.sec.android.app.sbrowser&hl=en_IN&gl=US",
};

export const TYPES = { INAPP: "inapp", MOBILE: "mobile" };
